module.exports = __webpack_public_path__ + "static/media/ic-powerful-analytics-reports.eb22b6c1.svg";